import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import './index.scss';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { createAuth0Client } from '@auth0/auth0-spa-js';
import config from './config';
import Auth0SessionInfo from './Services/Auth0SessionInfo';
import enableSessionStorageBetweenTabs from './enableSessionStorageBetweenTabs';
import { initializeAgGridLicense } from './agGridLicense';

enableSessionStorageBetweenTabs();
initializeAgGridLicense();

const root = createRoot(document.getElementById('root'));

createAuth0Client({
  domain: config.auth0.domain,
  clientId: config.auth0.clientId,
  authorizationParams: {
    redirect_uri: config.auth0.callbackUrl,
    audience: config.auth0.audience,
  },
  useRefreshTokens: true
}).then(async authClient => {
  if (/code|state|error/.test(window.location.search)) {
    try {
      await authClient.handleRedirectCallback(window.location.search);
    } catch (e) {
      // In incognito mode the stored state may be lost, causing "Invalid state".
      // Clear the stale query params and trigger a fresh login.
      const pathname = window.location.pathname;
      window.history.replaceState({}, document.title, pathname);
      const callbackURL = (pathname !== "/callback" && pathname !== "/logout") ? pathname : "/";
      window.localStorage.setItem("callbackURL", callbackURL);
      authClient.loginWithRedirect();
      return;
    }
  }
  
  const authenticated = await authClient.isAuthenticated();
  var interval = null;
  let callbackURL = "/";

  if (authenticated)
  {
    await Auth0SessionInfo.SetSessionInfo(authClient);
    interval = await Auth0SessionInfo.SetRefreshTokenInterval(authClient);
  } else {
    callbackURL = (window.location.pathname !== "/callback" && window.location.pathname !== "/logout") ? window.location.pathname : "/";
    window.localStorage.setItem("callbackURL", callbackURL)
  }

  if (!authenticated) {
    authClient.loginWithRedirect();
    return;
  }

  root.render(
    <BrowserRouter unstable_useTransitions={false}>
      <App authClient={authClient} interval={interval}/>
    </BrowserRouter>);
});

// DD 5/10/2021 This comes from the newer version of PWA template
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();